var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"form-title title pl-4 py-1"},[_c('b',[_vm._v(_vm._s(_vm.$route.params.title))])]),_c('div',{staticClass:"form-view"},[(_vm.loadComponent())?_c(_vm.loadComponent(),{tag:"component"}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }